import api, { request } from '../../../api';
import { getCurrentSeason } from '../../../scenes/player/Common/Utils/getCurrentSeason';
import { IStore } from '../../index';
import { ISeason } from '../store';

export const get = async (state: IStore, clubId: number, force?: boolean, isAdmin?: boolean) => {
  if (state.seasons[clubId] && !force) {
    return { seasons: state.seasons };
  }

  const response = isAdmin
    ? await request.get(`${api.admin.seasons(clubId)}`)
    : await request.get(`${api.seasons(clubId)}`);

  if (response.error) {
    return { errors: { seasons: { msg: 'Error fetching club seasons' } } };
  }

  const clubSeasons: ISeason[] = response;

  const currentSeason = getCurrentSeason(clubSeasons);

  return {
    seasons: {
      [clubId]: {
        currentSeason,
        seasons: clubSeasons
      }
    }
  };
};
